<template>
  <video-product-detail
    v-if="!loading"
    ref="product"
    :item="item"
    :actions-allowed="actionsAllowed"
    :offset="offset"
    v-on="$listeners"
  />
</template>

<script>
import VideoProductDetail from './VideoProductDetail';

export default {

  name: 'VideoProductDetailContainer',
  components: { VideoProductDetail },
  props: {
    productId: {
      type: [String, Number],
      required: true,
    },
    thumbnailUrl: {
      type: String,
      default: '',
    },
    actionsAllowed: {
      type: Boolean,
      default: false,
    },
    offset: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    item() {
      const product = this.$store.state.products.item;
      if (product !== null) {
        const arr = product.images;
        const thumbnailImage = arr.find((el) => el.image_url === this.thumbnailUrl);
        const thumbnailImageIndex = arr.indexOf(thumbnailImage);
        arr.splice(thumbnailImageIndex, 1);
        arr.splice(0, 0, thumbnailImage);
      }
      return product;
    },
  },
  watch: {
    productId: {
      handler(newval) {
        this.loading = true;
        this.$store.dispatch('products/fetchItem', this.productId).then(() => {
          this.loading = false;
        });
      },
      immediate: true,
    },
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="css" scoped>
</style>
